import {Component, Inject, Vue} from 'vue-property-decorator'

@Component
export default class TextProviderMixin extends Vue {

    @Inject({from: 'jds.text', default: () => (s: string) => s}) textProvider!: (s: string, p: {[key: string]: string}) => string;


    $text (key: string, pieces: {[key: string]: string} = {}) {
        return this.textProvider(key, pieces);
    }
}
